import React from 'react';

import { OrderFormContainer } from '../OrderForm/OrderFormContainer';
import { DonationFailure } from './DonationFailure';
import { DonationForm } from './DonationForm';
import { DonationSuccess } from './DonationSuccess';
import DonationFormContext from './DonationFormContext';

export const DonationContainer = (props) => {
  return (
    <DonationFormContext.Provider value={props}>
      <OrderFormContainer
        form={<DonationForm />}
        success={<DonationSuccess />}
        fail={<DonationFailure />}
      />
    </DonationFormContext.Provider>
  );
};
